import { render, staticRenderFns } from "./MyCourseList.vue?vue&type=template&id=46573073&"
import script from "./MyCourseList.vue?vue&type=script&lang=js&"
export * from "./MyCourseList.vue?vue&type=script&lang=js&"
import style0 from "./MyCourseList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports